import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/edi/platformportmapping'
import pathMap from 'src/paths/PathMap_EDI'

class PlaformPortMappingRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.PLATFORM_PORT_MAPPING_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.PLATFORM_PORT_MAPPING_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.PLATFORM_PORT_MAPPING_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.PLATFORM_PORT_MAPPING_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default PlaformPortMappingRoute
